var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62069 7.91595C5.95285 6.89987 7.508 6.23 8.28611 5.90636C10.5078 4.98228 10.9694 4.82176 11.2703 4.81646C11.3365 4.8153 11.4845 4.8317 11.5803 4.90947C11.6613 4.97515 11.6835 5.06386 11.6942 5.12612C11.7049 5.18839 11.7181 5.33023 11.7076 5.44106C11.5872 6.70604 11.0662 9.77583 10.8012 11.1926C10.6891 11.7921 10.4683 11.9932 10.2545 12.0128C9.78991 12.0556 9.43714 11.7058 8.98717 11.4108C8.28307 10.9493 7.88529 10.662 7.20184 10.2116C6.41199 9.6911 6.92402 9.40502 7.37415 8.9375C7.49195 8.81514 9.53888 6.95331 9.5785 6.78441C9.58345 6.76329 9.58805 6.68455 9.54127 6.64297C9.4945 6.60139 9.42546 6.61561 9.37564 6.62692C9.30502 6.64295 8.1802 7.38641 6.00119 8.8573C5.68192 9.07654 5.39273 9.18336 5.13362 9.17776C4.84798 9.17159 4.29852 9.01625 3.89006 8.88348C3.38905 8.72062 2.99087 8.63452 3.02554 8.35794C3.0436 8.21388 3.24199 8.06655 3.62069 7.91595Z",
    fill: "#078ACE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram2);
export default __webpack_public_path__ + "static/media/telegram2.6ac217b959b3c8076385372f30dd936a.svg";
export { ForwardRef as ReactComponent };